module.exports = __webpack_public_path__ + "img/9788972883586.6c66690f.jpg";